export default [
    '26 26',
    '<path d="M20.9746 0.249023H24.9633L16.2514 10.2038L26.5 23.7518H18.4774L12.1893 15.5372L5.00282 23.7518H1.00847L10.3249 13.1021L0.5 0.249023H8.72599L14.404 7.7575L20.9746 0.249023ZM19.5734 21.3677H21.7825L7.5226 2.50891H5.14972L19.5734 21.3677Z" fill="var(--p-icon-share-color, currentColor)"/>'
]